// Notifications.
import FILE_NOTIFICATION_BLING from '../../../audio/bling2.mp3';
import FILE_NOTIFICATION_BLIP from '../../../audio/blip.mp3';
import FILE_NOTIFICATION_BLUP from '../../../audio/bug.mp3';
import FILE_NOTIFICATION_BLINK from '../../../audio/click.mp3';
import FILE_NOTIFICATION_DUG from '../../../audio/dug.mp3';
import FILE_OFFER_BUBBLES from '../../../audio/offer-notification-bubbles.mp3';
import FILE_OFFER_CARTOON from '../../../audio/offer-notification-cartoon.mp3';
import FILE_OFFER_CLIMBING from '../../../audio/offer-notification-climbing.mp3';
import FILE_OFFER_HIGH from '../../../audio/offer-notification-high.mp3';
import FILE_OFFER_INCOMING from '../../../audio/offer-notification-incoming.mp3';
import FILE_OFFER_ONE_MORE from '../../../audio/offer-notification-one-more.mp3';
import FILE_OFFER_STONE from '../../../audio/offer-notification-stone.mp3';
import FILE_NOTIFICATION_POP from '../../../audio/pop.mp3';
import FILE_NOTIFICATION_SIGNAL from '../../../audio/signal.mp3';
// Offer notifications.
import FILE_NOTIFICATION_DEFAULT from '../../../audio/slck.mp3';

export const NO_SOUND = 'NO_SOUND';
export const NOTIFICATION_DEFAULT = 'NOTIFICATION_DEFAULT';
export const NOTIFICATION_BLING = 'NOTIFICATION_BLING';
export const NOTIFICATION_BLIP = 'NOTIFICATION_BLIP';
export const NOTIFICATION_BLINK = 'NOTIFICATION_BLINK';
export const NOTIFICATION_BLUP = 'NOTIFICATION_BLUP';
export const NOTIFICATION_DUG = 'NOTIFICATION_DUG';
export const NOTIFICATION_POP = 'NOTIFICATION_POP';
export const NOTIFICATION_SIGNAL = 'NOTIFICATION_SIGNAL';
export const OFFER_NOTIFICATION_INCOMING = 'OFFER_NOTIFICATION_INCOMING';
export const OFFER_NOTIFICATION_BUBBLES = 'OFFER_NOTIFICATION_BUBBLES';
export const OFFER_NOTIFICATION_STONE = 'OFFER_NOTIFICATION_STONE';
export const OFFER_NOTIFICATION_CLIMBING = 'OFFER_NOTIFICATION_CLIMBING';
export const OFFER_NOTIFICATION_HIGH = 'OFFER_NOTIFICATION_HIGH';
export const OFFER_NOTIFICATION_ONE_MORE = 'OFFER_NOTIFICATION_ONE_MORE';
export const OFFER_NOTIFICATION_CARTOON = 'OFFER_NOTIFICATION_CARTOON';

export const OFFER_INCOMING_FILE = FILE_OFFER_INCOMING;
export const NOTIFICATION_DEFAULT_FILE = FILE_NOTIFICATION_DEFAULT;

export const NOTIFICATION_SOUND_OPTIONS = [
  { label: 'Default', value: NOTIFICATION_DEFAULT },
  { label: 'Bling', value: NOTIFICATION_BLING },
  { label: 'Blink', value: NOTIFICATION_BLINK },
  { label: 'Blip', value: NOTIFICATION_BLIP },
  { label: 'Blup', value: NOTIFICATION_BLUP },
  { label: 'Dug', value: NOTIFICATION_DUG },
  { label: 'Pop', value: NOTIFICATION_POP },
  { label: 'Signal', value: NOTIFICATION_SIGNAL },
  { label: 'No sound', value: NO_SOUND },
];

export const OFFER_NOTIFICATION_SOUND_OPTIONS = [
  { label: 'Default', value: OFFER_NOTIFICATION_INCOMING },
  { label: 'Bubbles', value: OFFER_NOTIFICATION_BUBBLES },
  { label: 'Stonecutters', value: OFFER_NOTIFICATION_STONE },
  { label: 'Climbing', value: OFFER_NOTIFICATION_CLIMBING },
  { label: 'Fly High', value: OFFER_NOTIFICATION_HIGH },
  { label: 'One more for..', value: OFFER_NOTIFICATION_ONE_MORE },
  { label: 'Toon', value: OFFER_NOTIFICATION_CARTOON },
  { label: 'No sound', value: NO_SOUND },
];

export const AudioMap = {
  NO_SOUND: null,
  NOTIFICATION_DEFAULT: FILE_NOTIFICATION_DEFAULT,
  NOTIFICATION_BLING: FILE_NOTIFICATION_BLING,
  NOTIFICATION_BLIP: FILE_NOTIFICATION_BLIP,
  NOTIFICATION_BLINK: FILE_NOTIFICATION_BLINK,
  NOTIFICATION_BLUP: FILE_NOTIFICATION_BLUP,
  NOTIFICATION_DUG: FILE_NOTIFICATION_DUG,
  NOTIFICATION_POP: FILE_NOTIFICATION_POP,
  NOTIFICATION_SIGNAL: FILE_NOTIFICATION_SIGNAL,
  OFFER_NOTIFICATION_INCOMING: FILE_OFFER_INCOMING,
  OFFER_NOTIFICATION_BUBBLES: FILE_OFFER_BUBBLES,
  OFFER_NOTIFICATION_STONE: FILE_OFFER_STONE,
  OFFER_NOTIFICATION_CLIMBING: FILE_OFFER_CLIMBING,
  OFFER_NOTIFICATION_HIGH: FILE_OFFER_HIGH,
  OFFER_NOTIFICATION_ONE_MORE: FILE_OFFER_ONE_MORE,
  OFFER_NOTIFICATION_CARTOON: FILE_OFFER_CARTOON,
};
